import script from "./contact-us.vue?vue&type=script&setup=true&lang=js"
export * from "./contact-us.vue?vue&type=script&setup=true&lang=js"

import "./contact-us.vue?vue&type=style&index=0&id=4cc54f48&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Acer\\Desktop\\mav\\surkhet\\patient-portal-v2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cc54f48"]])

export default __exports__